import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface ImportedInvoiceDetailRowsProps {
  children: ReactNode
}

/** A list of `ImportedInvoiceDetailRow`s, shared by the general rows and every accordion body. */
export const ImportedInvoiceDetailRows = ({ children }: ImportedInvoiceDetailRowsProps): ReactElement => (
  <Styled.ImportedInvoiceDetailRowsWrapper>{children}</Styled.ImportedInvoiceDetailRowsWrapper>
)
